module.exports = __webpack_public_path__ + "static/media/9DESA31.53e06b9a.jpg";